import { render, staticRenderFns } from "./PanelCategoryItems.vue?vue&type=template&id=55e7dad5&scoped=true&"
import script from "./PanelCategoryItems.vue?vue&type=script&lang=js&"
export * from "./PanelCategoryItems.vue?vue&type=script&lang=js&"
import style0 from "./PanelCategoryItems.vue?vue&type=style&index=0&id=55e7dad5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e7dad5",
  null
  
)

export default component.exports